var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "jquery", "./images", "./addressBar", "./analytics", "./radioList", "./priceFormula", "./context"], function (require, exports, $, images_1, addressBar_1, analytics_1, radioList_1, priceFormula_1, context_1) {
    "use strict";
    exports.__esModule = true;
    function toggleAttributePanel(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        handleAttributePanel();
        var $button = $(evt.currentTarget);
        var $panel = $button.next(".attribute-panel");
        var $curPanel = $(".attribute-panel.shown");
        images_1.ensureImageLoaded($panel.find('img.asset[src="#"]'));
        $panel.add($curPanel).toggleClass("shown");
        if ($panel.hasClass("shown")) {
            var attrName = getAttrName($panel);
            analytics_1["default"]("product", "changing", attrName);
        }
    }
    exports.toggleAttributePanel = toggleAttributePanel;
    function handleAttributePanel() {
        if (context_1["default"].isMobile() && !$('.master-wrapper-content').data('track-panel')) {
            $('.attribute-panel').click(function (e) {
                e.stopPropagation();
            });
            $('.master-wrapper-content').on('click', function () {
                $('.attribute-panel.shown').toggleClass('shown', false);
            }).data('track-panel', true);
        }
    }
    function closePanel(evt, skipHistory) {
        if (skipHistory === void 0) { skipHistory = false; }
        var $cur = $(evt.currentTarget);
        if ($cur.hasClass("filters-open") && !skipHistory) {
            return;
        }
        var $panel = $cur.closest(".attribute-panel");
        $panel.toggleClass("shown", false);
        if (!skipHistory) {
            $panel.toggleClass("fade", true);
        }
        if (!skipHistory) {
        }
        $(".price-sheet-current").actionBar("refresh");
    }
    exports.closePanel = closePanel;
    function getAttrName($panel) {
        var attrName = $panel.find("input[data-attribute-name]").attr("data-attribute-name") ||
            $panel.next().data("attribute-name");
        if (!attrName) {
            attrName = $panel.find(">h2").text();
        }
        return attrName;
    }
    function onAttributePanelUpdate(evt, curDisplay) {
        var $panel = $(evt.currentTarget).closest(".attribute-panel");
        var $button = $panel.prev(".attribute-button");
        var $curDisplay = $button.find(".attribute-current");
        $curDisplay.text(curDisplay);
    }
    exports.onAttributePanelUpdate = onAttributePanelUpdate;
    function getPanelGroupValues($panel) {
        var attrNames = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            attrNames[_i - 1] = arguments[_i];
        }
        return attrNames.reduce(function (cur, attrName) {
            var _a;
            return __assign({}, cur, (_a = {}, _a[attrName] = $panel
                .find("input[type='hidden'][data-attribute-name='" + attrName + "']")
                .data("decimal"), _a));
        }, {});
    }
    exports.getPanelGroupValues = getPanelGroupValues;
    function onAttributePanelSelect(evt) {
        var $cur = $(evt.currentTarget);
        var $select = $cur.closest(".select");
        var $panel = $select.closest(".attribute-panel");
        var $button = $panel.prev(".attribute-button");
        if (!$cur.hasClass("selected")) {
            $panel.find(".select .option.selected").toggleClass("selected", false);
            $cur.toggleClass("selected");
        }
        if (!evt.isTrigger) {
            var attrName = getAttrName($panel);
            analytics_1["default"]("product", "changed", attrName);
            $button.toggleClass("missing", false);
        }
        var $qty = $cur.find('input[type="hidden"].productQty');
        if ($qty.length) {
            var prev = $panel.find('.option input[value!="0"]').val();
            $select.find('.option input[type="hidden"]').val(0);
            $qty.val(prev);
        }
        else {
            $panel
                .find('input[type="hidden"]')
                .data("decimal", $cur.data("decimal"))
                .val($cur.data("value"))
                .trigger("change");
        }
        if ($qty.length) {
            updateProductType($qty);
            $button
                .find(".attribute-current")
                .text($cur.find(".product-price-offer .title").text());
            $button.find(".attribute-description p").html($cur
                .find(".product-offer-detail")
                .html()
                .trim());
            $(".price-sheet-current .msrp").text($cur.find(".msrp").text());
            $(".price-sheet-current .offer-price").text($cur.find(".offer-price").text());
            var offerCost = Number($cur
                .find(".offer-price")
                .text()
                .substr(1));
            var offerPricing = { offerCost: offerCost };
            var discountedPricing = priceFormula_1.computeDiscountedPricing(offerPricing);
            if (discountedPricing != offerPricing) {
                $("#primary-discounted-price").text("$" + discountedPricing["offerCost"]);
            }
            addressBar_1.setHashQuery("formulaResult", $cur.find(".product-price-offer").attr("id"));
        }
        else {
            $button.find(".attribute-current").text($cur.text());
        }
        if ($panel.parent().hasClass("price-sheet-current-qty")) {
            var $priceSheet = $(".product-price-sheet");
            $priceSheet.find('.option.selected input[type="hidden"]').val($cur.text());
        }
    }
    function updateProductType($ptSelect) {
        var productType = $ptSelect.data("product-type");
        var $pt = $("#ProductType");
        var prev = $pt.val() || "0";
        if (prev != productType) {
            $pt.val(productType);
            $pt.trigger("change");
            var formulaResult = $ptSelect.find(".product-price-offer").attr("id");
            if (formulaResult) {
                addressBar_1.setHashQuery("formulaResult", formulaResult);
            }
        }
        return prev != productType;
    }
    function desktopChangeProductType($ptSelect) {
        if (updateProductType($ptSelect)) {
            $(".product-price-sheet .productQty").val(0);
            $ptSelect.find(".quantity .productQty").val($("#selected-qty").val());
        }
    }
    $(function () {
        radioList_1.radioList($(".env-desktop .product-price-sheet"), desktopChangeProductType);
        $(".env-desktop #selected-qty").change(function () {
            $(".product-price-sheet .option.selected .productQty").val($("#selected-qty").val());
        });
        $(".attribute-button:not(.disabled)").click(toggleAttributePanel);
        $(".attribute-panel .select .option").click(onAttributePanelSelect);
        $(".panel-close-button").click(closePanel);
        $(".panel-header").on("webkitAnimationEnd oanimationend msAnimationEnd animationend", function (evt) {
            var $panel = $(evt.currentTarget).closest(".attribute-panel");
            if ($panel.hasClass("fade")) {
                $panel.toggleClass("fade", false);
            }
        });
    });
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/attributePanel.js
// module id = 58
// module chunks = 0